import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout    from './components/Layout/Layout';
import Login     from './pages/Login';
import Dashboard from './pages/Dashboard';
import Attendance from './pages/Attendance';
import Grievances from './pages/Grievances';
import Homework   from './pages/Homework';
import Newsletter from './pages/Newsletter';
import LessonPlan          from './pages/LessonPlan';
import TeacherObservation  from './pages/TeacherObservation';
import Teachers            from './pages/Teachers';
import SchoolConfiguration from './pages/SchoolConfiguration';
import LearningTrackers    from './pages/LearningTrackers';
import ErpSync             from './pages/ErpSync';
import BiometricSync       from './pages/BiometricSync';
import MorningActivity        from './pages/MorningActivity';
import PerformanceAnalytics  from './pages/PerformanceAnalytics';
import Timetable             from './pages/Timetable';
import LeaveManagement       from './pages/LeaveManagement';
import LessonPlannerWF          from './pages/LessonPlannerWF';
import LessonPlannerEditor      from './pages/LessonPlannerEditor';
import ParentTeacherConnect     from './pages/ParentTeacherConnect';
import EnrichmentProgramme      from './pages/EnrichmentProgramme';
import Reports                  from './pages/Reports';
import FeedbackPortal            from './pages/FeedbackPortal';
import BookingPortal             from './pages/BookingPortal';
import Transport                 from './pages/Transport';
import TransportParentPortal     from './pages/TransportParentPortal';

import LoadingSpinner      from './components/Common/LoadingSpinner';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center bg-primary-50"><LoadingSpinner size="lg" /></div>;
  return user ? children : <Navigate to="/login" replace />;
}

function ModuleRoute({ module, children }) {
  const { hasModule, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center bg-primary-50"><LoadingSpinner size="lg" /></div>;
  if (!hasModule(module)) return <Navigate to="/" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center bg-primary-50"><LoadingSpinner size="lg" /></div>;
  return user ? <Navigate to="/" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/feedback/:token"         element={<FeedbackPortal />} />
      <Route path="/ptc-book/:token"         element={<BookingPortal />} />
      <Route path="/transport-parent/:token" element={<TransportParentPortal />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index                 element={<Dashboard />} />
        <Route path="teachers"           element={<Teachers />} />
        <Route path="attendance"         element={<ModuleRoute module="attendance"><Attendance /></ModuleRoute>} />
        <Route path="grievances"         element={<ModuleRoute module="grievances"><Grievances /></ModuleRoute>} />
        <Route path="homework"           element={<ModuleRoute module="homework"><Homework /></ModuleRoute>} />
        <Route path="newsletter"         element={<ModuleRoute module="newsletter"><Newsletter /></ModuleRoute>} />
        <Route path="lesson-plan"        element={<ModuleRoute module="lesson_plan"><LessonPlan /></ModuleRoute>} />
        <Route path="teacher-observation"  element={<ModuleRoute module="teacher_observation"><TeacherObservation /></ModuleRoute>} />
        <Route path="learning-trackers"   element={<ModuleRoute module="learning_trackers"><LearningTrackers /></ModuleRoute>} />
        <Route path="morning-activity"    element={<ModuleRoute module="morning_activity"><MorningActivity /></ModuleRoute>} />
        <Route path="performance"         element={<ModuleRoute module="performance_analytics"><PerformanceAnalytics /></ModuleRoute>} />
        <Route path="timetable"           element={<ModuleRoute module="timetable"><Timetable /></ModuleRoute>} />
        <Route path="leave"               element={<ModuleRoute module="leave_management"><LeaveManagement /></ModuleRoute>} />
        <Route path="lesson-planner"      element={<ModuleRoute module="toddle_planner"><LessonPlannerWF /></ModuleRoute>} />
        <Route path="lesson-planner/:id"  element={<ModuleRoute module="toddle_planner"><LessonPlannerEditor /></ModuleRoute>} />
        <Route path="ptc"                   element={<ModuleRoute module="ptc"><ParentTeacherConnect /></ModuleRoute>} />
        <Route path="enrichment"            element={<ModuleRoute module="enrichment_programme"><EnrichmentProgramme /></ModuleRoute>} />
        <Route path="reports"               element={<ModuleRoute module="reports"><Reports /></ModuleRoute>} />
        <Route path="transport"             element={<ModuleRoute module="transport"><Transport /></ModuleRoute>} />
        <Route path="school-config"       element={<SchoolConfiguration />} />
        <Route path="erp-sync"            element={<ErpSync />} />
        <Route path="biometric-sync"      element={<BiometricSync />} />

      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#fff',
              color: '#0f172a',
              borderRadius: '12px',
              boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
              border: '1px solid #e2e8f0',
              fontSize: '14px',
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}
